import type { ORPCClient, Outputs } from '@/lib/orpc'
import { useState } from 'react'
import { useQueryClient } from '@tanstack/react-query'
import { useRouter } from '@tanstack/react-router'

import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle
} from '../ui/dialog'
import RotateApiKeyForm from './rotate-api-key-form'

interface RotateApiKeyModalProps {
  apiKey: Outputs['backoffice']['apiKeys']['getAll'][number]
  orpc: ORPCClient
}

export default function RotateApiKeyModal({
  children,
  apiKey,
  orpc
}: React.PropsWithChildren<RotateApiKeyModalProps>) {
  const router = useRouter()
  const queryClient = useQueryClient()
  const [open, setOpen] = useState(false)

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      {children}
      <DialogContent
        onOpenAutoFocus={(e) => e.preventDefault()}
        className="max-w-sm"
      >
        <DialogHeader>
          <DialogTitle>API Key</DialogTitle>
          <DialogDescription className="text-xs">
            Perbarui atau akses detail API Key{' '}
            <span className="text-foreground/80 font-medium italic">
              {apiKey.name}
            </span>
            . API Key akan otomatis tidak berlaku{' '}
            <span className="text-foreground/80 font-medium italic">
              setelah 1 tahun
            </span>
            . Jadi pastikan untuk tidak memperbaruinya terlalu sering, kecuali
            jika memang diperlukan.
          </DialogDescription>
        </DialogHeader>
        <div className="grid gap-4">
          <RotateApiKeyForm
            initialApiKey={apiKey}
            onClose={(newApiKey) => {
              setOpen(false)
              if (newApiKey !== apiKey.key) {
                queryClient.invalidateQueries({
                  queryKey: orpc.backoffice.apiKeys.getAll.queryKey()
                })
                router.invalidate()
              }
            }}
            orpc={orpc}
          />
        </div>
      </DialogContent>
    </Dialog>
  )
}
